import { Outlet } from '@tanstack/react-router';
import { useDevice } from '@/hooks/useDevice';
import { DesktopShell } from './DesktopShell';
import { MobileShell } from './MobileShell';
import { TVShell } from './TVShell';

export function RootLayout() {
  const device = useDevice();
  const inner = <Outlet />;
  if (device === 'tv') return <TVShell>{inner}</TVShell>;
  if (device === 'mobile') return <MobileShell>{inner}</MobileShell>;
  return <DesktopShell>{inner}</DesktopShell>;
}
